import type { InputHTMLAttributes, ReactNode } from "react";

type FieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string;
  error?: string;
  icon?: ReactNode;
};

export function Field({ label, hint, error, icon, id, ...props }: FieldProps) {
  const inputId = id ?? props.name;
  const messageId = `${inputId}-message`;

  return (
    <label className={`field${error ? " field--error" : ""}`} htmlFor={inputId}>
      <span className="field__label">{label}</span>
      <span className="field__input-shell">
        {icon ? <span aria-hidden="true" className="field__icon">{icon}</span> : null}
        <input
          aria-describedby={hint || error ? messageId : undefined}
          aria-invalid={Boolean(error)}
          className="field__input"
          id={inputId}
          {...props}
        />
      </span>
      {(error || hint) && (
        <span className="field__message" id={messageId}>
          {error ?? hint}
        </span>
      )}
    </label>
  );
}
